import { render } from "./DateTime.vue?vue&type=template&id=0c4d6388&ts=true"
import script from "./DateTime.ts?vue&type=script&lang=ts&external"
export * from "./DateTime.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__